import React, { useEffect, useState } from "react";
import { ArrowRight, Medal, Tv } from "lucide-react";
import api from "../lib/api";
import { TV, TvKicker } from "./TriviaTheme";

export const SportingMoments = ({ onPlay, onSportNight }) => {
  const [sports, setSports] = useState([]);
  const [sport, setSport] = useState("");
  const [event, setEvent] = useState("");
  useEffect(() => { api.get("/trivia/sports").then((r) => setSports(r.data)).catch(() => {}); }, []);
  if (!sports.length) return null;
  const total = sports.reduce((n, s) => n + s.total, 0);
  const cur = sports.find((s) => s.sport === sport);
  const n = cur ? (event ? cur.events.find((e) => e.event === event)?.count || 0 : cur.total) : total;
  const pick = (s) => { setSport(s); setEvent(""); };
  return (
    <div className="mt-10" data-testid="sporting-moments">
      <TvKicker line={false}>Special rounds</TvKicker>
      <h2 className="font-ui font-bold text-xl sm:text-2xl text-[#161514] mt-2 mb-4">Sporting moments</h2>
      <div className={`${TV.card} p-5 sm:p-6 tv-rise`}>
        <div className="flex items-start justify-between gap-3">
          <div>
            <p className="tv-caps text-[#57524B]">World Cups, Olympics, finals & world records</p>
            <p className="font-ui font-bold text-lg text-[#161514] mt-2 leading-snug">Winners, hosts and record-breakers from 1877 to today</p>
          </div>
          <span className="w-9 h-9 shrink-0 rounded-full bg-[#EEE8DD] flex items-center justify-center"><Medal className="w-4 h-4 text-[#161514]" /></span>
        </div>
        <div className="flex flex-wrap gap-1.5 mt-4" data-testid="sport-picker">
          {[{ sport: "" }, ...sports].map((s) => (
            <button key={s.sport || "all"} data-testid={`sport-pill-${(s.sport || "all").toLowerCase().replace(/\s+/g, "-")}`} onClick={() => pick(s.sport)}
              className={`px-3 py-1 rounded-full font-ui text-xs font-semibold border transition-[background-color,color] ${sport === s.sport ? "bg-[#161514] text-white border-[#161514]" : "bg-[#EEE8DD] text-[#4A453E] border-[#DDD5C7] hover:bg-[#E6DFD2]"}`}>
              {s.sport || "All sports"}
            </button>
          ))}
        </div>
        {cur && cur.events.length > 1 && (
          <select data-testid="sport-event-select" value={event} onChange={(e) => setEvent(e.target.value)}
            className="mt-3 w-full sm:w-auto rounded-full border border-[#DDD5C7] bg-[#F7F4EE] px-4 py-2 font-ui text-sm text-[#161514] focus:outline-none focus:border-[#2D4A3E]">
            <option value="">{`All ${cur.sport.toLowerCase()} events`}</option>
            {cur.events.map((e) => <option key={e.event} value={e.event}>{`${e.event} (${e.count})`}</option>)}
          </select>
        )}
        <div className="flex items-center justify-between gap-3 mt-5">
          <span className="font-ui text-xs text-[#77716A]" data-testid="sport-count">{n.toLocaleString()} questions</span>
          <button data-testid="play-sporting-moments" disabled={!n}
            onClick={() => onPlay({ pack: "sporting-moments", ...(sport ? { sport } : {}), ...(event ? { event } : {}) })}
            className={`${TV.pillDark} inline-flex items-center gap-1.5 px-4 py-2 font-ui text-sm font-semibold disabled:opacity-40`}>
            Play round <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
      <button data-testid="sport-night-card" onClick={onSportNight}
        className="mt-3 w-full text-left bg-[#161514] text-white rounded-[20px] p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4 hover:-translate-y-0.5 transition-transform tv-rise">
        <div className="flex items-start gap-4">
          <span className="w-11 h-11 shrink-0 rounded-full bg-white/10 flex items-center justify-center"><Tv className="w-5 h-5" /></span>
          <div>
            <p className="tv-caps text-white/60">Host mode · Club</p>
            <p className="font-ui font-bold text-lg sm:text-xl mt-1">Group Sport Night</p>
            <p className="font-ui text-[13px] text-white/70 mt-1">A big-screen, sport-by-sport quiz from football to US sports, with team scores.</p>
          </div>
        </div>
        <span className="shrink-0 self-start sm:self-center inline-flex items-center gap-1.5 bg-white text-[#161514] rounded-full px-4 py-2 font-ui text-sm font-semibold">Host a night <ArrowRight className="w-4 h-4" /></span>
      </button>
    </div>
  );
};
